<template lang="pug">
  tfoot#no-pdf
    td(colspan=10)
      .datatable-controls.no-pdf
        a.button(href='#', @click="downloadPDF") Download PDF
        a.button(href='#', @click="downloadCSV") Download CSV
        a.button(href='#', @click="downloadXLS") Download XLS
</template>

<script>
import downloadCSV from './lib/downloadCSV'
import downloadPDF from './lib/downloadPDF'
import downloadXLS from './lib/downloadXLS'

export default {
  name: 'table-footer',
  props: ['columns', 'rows'],
  methods: {
    toggleOrder (id) {
      if (this.OrderBy !== id) {
        this.Order = 'DESC'
      } else {
        this.Order = (this.Order === 'ASC') ? 'DESC' : 'ASC'
      }
      this.OrderBy = id
    },
    downloadCSV () { downloadCSV(this.columns, this.rows) },
    downloadPDF () { downloadPDF(this.columns, this.rows) },
    downloadXLS () { downloadXLS(this.columns, this.rows) }
  }
}
</script>

<style lang="stylus" scoped>
.button {
  padding: 5px
  color: white
  background: green
  font-size: 10px
  border-radius: 4px
  text-decoration: none
  margin-right: 10px

  &:last-child {
    margin-right: 0px
  }
}

tfoot {
  display: table-row
  height: auto
}

.datatable-controls {
  height: auto
  z-index: 1
  display: flex
  align-items: center
  position: absolute
  top: 0
  right: 0
}
</style>

<style lang="stylus">
.page.type-page {
  position relative
}
</style>



// WEBPACK FOOTER //
// table-footer.vue?1504755d